import CONFIG from "../temp/config";
import {mygaSession} from "./myga-session";
import {MM_PRODUCT_FAMILY, PRODUCT_FAMILY_RATE_FILE} from "./myga-model";
import {NassauLog} from "./myga-utils";

export let MygaRates = {

  SixYear : "",
  FourYear : ""

};

export let loadMygaRates = async () => {
  let url = CONFIG.nsreAPI.mygaRates;
  let response = await fetch(url, {
    method: 'GET',
    headers: {
      //'Content-Type': 'application/json',
      //'credentials': 'include',
    },
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  let rates = await response.json();
  
  // 2021.09.29.ADivelbiss - Uncomment next two lines to simulate a rate change
  // mygaSession.getMygaRateForPeriod('4',rates).rate += Math.random()*0.2;
  // mygaSession.getMygaRateForPeriod('6',rates).rate += Math.random()*0.2;
  
  return await mygaSession.setMygaRates(rates);
};

export let loadBankRates = async () => {
  let url = CONFIG.nsreAPI.bankRatesNew;
  let response = await fetch(url, {
    method: 'GET',
    headers: {
      //'Content-Type': 'application/json',
      //'credentials': 'include',
    },
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  } else {
    let rates = await response.json();
    return await mygaSession.setBankRates(rates);
  }
};

export let loadTreasuryRates = async () => {
  let url = CONFIG.nsreAPI.treasuryRates;
  let response = await fetch(url, {
    method: 'GET',
    headers: {
    },
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  } else {
    let rates = await response.json();
    return await mygaSession.setTreasuryRates(rates);
  }
};

// 2021.01.28.ADivelbiss - added to support landing footnote date.
export let loadRateFile = async () => {
  let url = CONFIG.nsreAPI.rateFileUrl;
  let response = await fetch(url, {
    method: 'GET',
    headers: {
      //'Content-Type': 'application/json',
      //'credentials': 'include',
    },
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  let rates = await response.json();
  
  return await mygaSession.setRateFile(rates);
};

/**
 * Load the rate file for a given product family name.
 * @param productFamily
 * @returns {Promise<*>}
 */
export const loadProductRates = async (productFamily) => {
  let url = CONFIG.nsreAPI.rateFileBaseUrl + PRODUCT_FAMILY_RATE_FILE[productFamily];
  let response = {ok:false};
  try {
    response = await fetch(url, {
      method: 'GET',
      headers: {
        // 'Content-Type': 'application/json',
        // 'credentials': 'include',
      },
    });
  } catch (e) {
    NassauLog(`loadProductRates error: ${e.message}`)
  }
  
  if (!response.ok) {
    url = 'assets/rates/' + PRODUCT_FAMILY_RATE_FILE[productFamily];
    response = await fetch(url, {
      method: 'GET',
      headers: {
        // 'Content-Type': 'application/json',
        // 'credentials': 'include',
      },
    });
  }
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const rates = await response.json();
  mygaSession.setProductRates(productFamily,rates);
  return rates;
}

export const loadMygaProductRates = async () => {
  await Promise.all(Object.values(MM_PRODUCT_FAMILY).map(family=>loadProductRates(family)));
  return mygaSession.getProductRates();
}